<template>
  <fieldset>
    <label :for="`input-${prefix}-${address.id}`">{{ addressLabel }}</label>
    <div class="input-gabarit">
      <Field v-slot="{ field, errorMessage }" :name="`input-${prefix}-${address.id}`" :rules="{ is: !googleSuggested }">
        <input
          v-bind="field"
          :id="`input-${prefix}-${address.id}`"
          autocomplete="off"
          type="text"
          :class="{ 'has-error': !!errorMessage }"
          placeholder="Adresse du collaborateur rejetée"
          :value="address.formatted"
          @input="e => inputOnChange(e, idx)"
        />
        <span class="flag-box">
          <i v-if="address.formatted && !errorMessage && address.formatted !== address.originalFormatted" class="icon-checkstatus"></i>
          <i v-else-if="address.formatted && address.levenstein >= 8" class="icon-alert"></i>
          <i v-if="address.isExcluded" class="icon-zone"></i>
        </span>
        <div v-if="suggestions[idx] && suggestions[idx].length > 0 && !isIE" class="autocomplete-dropdown">
          <div
            v-for="(suggestion, idx2) in suggestions[idx]"
            :key="idx2"
            class="autocomplete-entry"
            @click="() => updateAddress(idx, address.id, suggestion.description)"
          >
            {{ suggestion.description }}
          </div>
        </div>
        <span class="error-caption">{{ errorMessage }}</span>
      </Field>
    </div>
  </fieldset>
</template>

<script>
import { Field } from 'vee-validate';

export default {
  components: { Field },
  props: ['address', 'idx', 'prefix'],

  data() {
    return {
      suggestions: [],
      googleSuggested: true,
    };
  },

  computed: {
    isIE() {
      const ua = navigator.userAgent;
      /* MSIE used to detect old browsers and Trident used to newer ones */
      return ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;
    },

    addressLabel() {
      if (this.address.coordinatesProvided) {
        return `${this.address.jllId} : ${this.address.latlong.latitude}, ${this.address.latlong.longitude}`;
      }

      // first input is checked on length as sometimes it just contains a single coma
      if (this.address.firstInput.trim().length > 1) {
        return `${this.address.jllId} : ${this.address.firstInput}`;
      }

      return `${this.address.jllId}`;
    },
  },

  created() {
    this.gMaps = google.maps;
  },

  methods: {
    inputOnChange(e, idx) {
      const { value } = e.target;
      const oldValue = this.address.formatted;
      // eslint-disable-next-line vue/no-mutating-props
      this.address.formatted = value;
      this.$emit('updateAddress', { value, oldValue });
      this.googleSuggested = false;
      if (value.length > 5) {
        this.getQueryPredictions(value, idx);
      } else {
        this.suggestions[idx] = [];
      }
    },

    getQueryPredictions(input, idx) {
      const { sessionToken } = this;
      const service = new this.gMaps.places.AutocompleteService();
      service.getQueryPredictions(
        {
          input,
          sessionToken,
        },
        (predictions, status) => this.displaySuggestions(predictions, status, idx),
      );
    },

    displaySuggestions(predictions, status, idx) {
      if (status !== this.gMaps.places.PlacesServiceStatus.OK) {
        this.suggestions[idx] = [];
        return;
      }
      this.suggestions[idx] = predictions;
    },

    updateAddress(idx, id, value) {
      this.suggestions[idx] = [];
      const oldValue = this.address.formatted;
      // eslint-disable-next-line vue/no-mutating-props
      this.address.formatted = value;
      this.$emit('updateAddress', { value, oldValue });
      this.googleSuggested = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
.input-gabarit {
  position: relative;
}
.flag-box {
  position: absolute;
  white-space: nowrap;
  i {
    font-size: 2em;
    color: #bc141a;
    &.icon-checkstatus {
      color: #1daea1;
    }
  }
}
.autocomplete-dropdown {
  margin-top: -17px;
  margin-bottom: 16px;
  border: 1px solid #e3e3e3;

  .autocomplete-entry {
    line-height: 2;
    padding: 0 0.5em;
    cursor: pointer;
    & + .autocomplete-entry {
      border-top: 1px solid #e3e3e3;
    }
  }
}
label {
  padding-bottom: 4px;
  overflow: visible;
}
.warning-tag {
  background-color: #bc141a;
  font-size: 11px;
  color: white;
  border-radius: 2px;
  padding-left: 7px;
  padding-right: 7px;
}
</style>
